module.exports = __webpack_public_path__ + "static/media/03_CALCINHA_ASA_DELTA_08.f69d1742.jpg";